import { Box } from '@mui/material';
import UnderwriterRelatedQuotes from '../../../../../../primeX-underwriter/components/UnderwriterRelatedQuotes';
import { InputLabelBase } from '../../../../../../../../components/inputs/InputLabelBase';
import { useUnderwriterContext } from '../../provider/UnderwriterProvider';
import { isUnderwriterContext } from '../../types';
import { UW_GLOBAL_LABEL_STYLE } from '../uwTileSpacing';

const UwQuoteList = () => {
  const context = useUnderwriterContext();

  if (!isUnderwriterContext(context)) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '1rem',
      }}
    >
      <Box>
        <InputLabelBase
          style={{
            padding: 0,
            paddingBottom: '0.25rem',
            visibility: 'hidden',
            // Same line as Carrier's label, so the two controls align.
            ...UW_GLOBAL_LABEL_STYLE,
          }}
        >
          Spacer
        </InputLabelBase>
        {/* @ts-expect-error: FIXME */}
        <UnderwriterRelatedQuotes
          quotesList={context.state.quoteList}
          quoteDetails={context.state.quote}
          productType={context.state.productType}
          filled
        />
      </Box>
    </Box>
  );
};

export default UwQuoteList;
